import React, { Component, useContext } from 'react'
import { AppGridLayoutContext } from './AppGridLayout'

export const AppGridHeard = (props: { children: any }) => {
	const context = useContext(AppGridLayoutContext)
	return (
		<div ref={context.refAppGridHeard} className="app-grid-heard">
			{props.children}
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/components/AppGridLayout/AppGridHeard.tsx